import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { startMockWorker } from '@mock/msw/start-mock-worker';

// the mock worker must be up before the first request, which can come while the app is still bootstrapping
startMockWorker()
  .then(mockProviders =>
    bootstrapApplication(AppComponent, { ...appConfig, providers: [...appConfig.providers, ...mockProviders] })
  )
  .catch(err => {
    console.error(err);
  });
